import { render, staticRenderFns } from "./AS_QrtlyAccountStatementMoP.vue?vue&type=template&id=71ca8f62&scoped=true&"
import script from "./AS_QrtlyAccountStatementMoP.vue?vue&type=script&lang=js&"
export * from "./AS_QrtlyAccountStatementMoP.vue?vue&type=script&lang=js&"
import style0 from "./AS_QrtlyAccountStatementMoP.vue?vue&type=style&index=0&id=71ca8f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca8f62",
  null
  
)

export default component.exports